/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'doom',
    quality: 0,
    learning: -13,
	perception: -13,
	mana: -13,
	toughness: -13,
	strength: -13,
	willpower: -13,
	dexterity: -13
}